import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from '@phosphor-icons/react';

const AmazonSection = ({ onOpenModal }) => {
  return (
    <section data-testid="cta-dark-section" className="relative py-28 overflow-hidden">
      {/* Full background image */}
      <div className="absolute inset-0">
        <img 
          src="/assets/img/cta-bg.jpg" 
          alt="" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/85"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#D4AF37] mb-4">
          Your Brand Deserves Strong Protection
        </p>
        <h2 className="text-3xl sm:text-4xl font-heading font-medium text-white tracking-tight mb-6">
          Don't Risk Losing Your Brand.
        </h2>
        <p className="text-base text-slate-300 leading-relaxed mb-10 max-w-2xl mx-auto">
          Register your trademark now to protect your intellectual property and secure your market position before conflicts arise.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            data-testid="cta-register-btn"
            onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - CTA Section')}
            className="bg-[#044B3B] hover:bg-[#03392D] text-white font-semibold text-sm px-8 py-5 rounded-md"
          >
            <span className="flex items-center gap-2">Start Registration <ArrowRight className="h-4 w-4" /></span>
          </Button>
          <Button
            data-testid="cta-chat-btn"
            onClick={() => window.cd360Api && window.cd360Api.liveChat.showWebWidget()}
            className="bg-transparent border border-white/30 text-white hover:bg-white/10 font-semibold text-sm px-8 py-5 rounded-md"
          >
            Speak with an Attorney
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AmazonSection;
